import { AfterViewInit, Component, OnInit, TemplateRef } from '@angular/core';
import { PlaylistService } from '../../services/playlist.service';
import { UtilService } from '../../services/util.service';
import { BsModalService, BsModalRef, ModalBackdropComponent } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { MessageService } from '../../services/message.service';
import { Constant } from '../../services/data';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthentictionService } from '../../services/authentiction.service';
import { MovieService } from '../../services/movie.service';
import { SeriesService } from '../../services/series.service';
import { LivestreamService } from '../../services/livestream.service';
import { LoadingDbModalComponent } from '../../../Shared/modal/dbloading-modal/dbloading-modal.component';
import { Moviesdb } from '../../services/dexiedb/moviedb.service';

declare var bootstrap: any;

@Component({
  selector: 'app-play-list',
  templateUrl: './play-list.component.html',
  styleUrls: ['./play-list.component.css']
})
export class PlayListComponent implements OnInit ,AfterViewInit{
  
  playListModal: any = {
    type: 'fromUrl',
    name: '',
    userName: '',
    password: '',
    url: ''
  };

  playList: any = [];
  filterPlayList:any =[];
  xstreamList: any;
  isLoading: boolean = false;
  
  bsModalRef: BsModalRef;
  // url_pattern = "([a-z0-9-]+\:\/+)([^\/\s]+)([a-z0-9\-@\^=%&;\/~\+]*)[\?]?([^ \#\r\n]*)#?([^ \#\r\n]*)";
  // url_pattern = "(https?:\/\/)([a-zA-Z0-9.-]+)(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?"
 url_pattern = /^https?:\/\/.+/;

  // XuserId: any;
  userid: any
  type='password';
  showCloudUpload:any;
  editModel: any = {};
  isLogin:boolean = false;
  progress = 0;
  totalTasks = 6;
  loadingItems = [
  { label: 'Live TV', loaded: false, progress: 0 },
  { label: 'Movies', loaded: false, progress: 0 },
  { label: 'Series', loaded: false, progress: 0 }
];

  overallProgress = 0;
  currentLabel = '';
  isLoadingdb:boolean = false;
  device_id:string;
  playlistM3u: any = [];

  constructor(private moviesService:MovieService,private seriesService:SeriesService,private livetvService:LivestreamService,private authService:AuthentictionService,private utilService: UtilService, private playlistService: PlaylistService, private modalService: BsModalService, private messageService: MessageService, private router: Router) {
  }

  ngOnInit(): void {

    const UserData = JSON.parse(this.utilService.getFullUserId()) || '' ;
    const uToken = (this.utilService.getValueCookie(Constant.USERTOKEN)) || '';
    const login_device = localStorage.getItem('login_device') || '';
    this.device_id = login_device;
      this.getPlaylistBydeviceId(this.device_id)
  
    if(uToken){
      this.isLogin = true;
  
    }else{
      this.isLogin = false;
  
    }
    this.userid = UserData.user_id
    // this.playListModal.type = "onestreamUrl"
    if (uToken) {
      this.getPlayList();
      // setTimeout(() => {
      // }, 1000);
    }else {
      this.getLocalPlaylist()
    }
  }

  ngAfterViewInit(): void {
    // this.utilService.switchPlaylist()
  
  }

  getPlayList() {
    this.playList = [];
    let passModel: any = {
      userid: ''
    };
    // this.XuserId = this.utilService.getFullUserId();
    // if (this.XuserId) {
    //   passModel.userid = this.XuserId;
    // } else {
    passModel.userid = this.utilService.getFullUserId();
    // }
    this.utilService.showSpinner()
    this.getPlaylistBydeviceId(this.device_id);

    this.isLoading = true;
    // this.playlistService.getPlayList(passModel).subscribe((res: any) => {
    //   this.isLoading = false;
    //   this.utilService.hideSpinner()

    //   if (res.http_code == 200) {
    //     if (res.m3u) {
    //       res.m3u.map((ele: any) => {
    //         if (ele._id) {
    //           ele.isM3u = true;
    //           this.playList.push(ele);
    //         }
    //       });
    //     }
    //     if (res.xstream) {
    //       res.xstream.map((ele: any) => {
    //         ele.isXstream = true;
    //         this.playList.push(ele);
    //       });

    //     }
    //     console.log(this.playList);
    //   }
    // }, err => {
    //   this.isLoading = false;
    //   this.utilService.hideSpinner()

    //   this.utilService.showErrorCall(err);
    // });
    this.playlistService.getNewPlaylist().subscribe((res:any) =>{
      if(res.status === 'success'){
        console.log(res);
        this.playList = res.data;
        localStorage.setItem('purple_playlist',JSON.stringify(this.playList))
        this.showCloudUpload = this.playList.length;
        console.log(this.showCloudUpload,'cloud length');
        this.filterPlayList = res.data;
        this.isLoading = false;
        this.getPlaylistBydeviceId(this.device_id);
        const localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        // const purplePlaylists = JSON.parse(localStorage.getItem('purple_playlist_local') || '[]');
        // const purpleLocal = localStorage.getItem('purple_local') === 'true';
        // if(purpleLocal){
        // const mergeData = [...localPlaylists,...purplePlaylists];
        // this.filterPlayList = [...this.filterPlayList,...mergeData];
        // }else{
        // }
         // Filter out local items that are already present in purple playlist (by id)
  // const updatedLocalPlaylists = localPlaylists.filter((local: any) => {
  //   return !this.playList.some((playlist: any) => playlist.id === local.id);
  // });
  const updatedLocalPlaylists = localPlaylists.filter((local: any) => {
  return !this.playList.some((playlist: any) =>
    playlist.id === local.id && playlist.playlist_name === local.playlist_name
  );
});


  // Update localStorage with cleaned local playlists
  localStorage.setItem('xstream_playlists', JSON.stringify(updatedLocalPlaylists));
        this.filterPlayList = [...this.filterPlayList, ...updatedLocalPlaylists];
        console.log(this.filterPlayList,'asdf');
        this.utilService.hideSpinner();
      }
    },err =>{
      if(err.message == "Http failure response for https://login.purpletv.app/api/get-playlists: 401 OK"){
      window.location.reload()
      }
      this.isLoading = false;
      this.utilService.hideSpinner();
      
    })
  }
  
  // getPlaylistBydeviceId(id: any) {
  // this.authService.playlistBydeviceId(id).subscribe((res: any) => {
  //   console.log(res);
  //   if (res.success === true && Array.isArray(res.data)) {
  //     const devicePlaylistData = res.data
  //       .filter((item: any) => item.playlist !== null)
  //       .map((item: any) => ({
  //         ...item.playlist,
  //         device_id: item.device_id,
  //         local:true,
  //         app_mode:'activate'
  //       }));

  //     this.filterPlayList = [...(this.filterPlayList || []), ...devicePlaylistData];
  //     if(this.filterPlayList.length>0){
  //     localStorage.setItem('iscode','true')        
  //     }else{
  //     localStorage.setItem('iscode','false')  
  //     }
  //     console.log(this.filterPlayList, 'Final Playlists');
  //   }
  // });
  // }
 getPlaylistBydeviceId(id: any) {
  const cachedData = localStorage.getItem('xstream_playlists');
  let parsedData = cachedData ? JSON.parse(cachedData) : [];

  // Check for activate mode
  const hasActiveMode = parsedData.some((item: any) => item.app_mode === 'activate');

  if (hasActiveMode) {
    console.log('Loaded from localStorage with app_mode: activate:', parsedData);
    return;
  }

  // Fetch from API
  this.authService.playlistBydeviceId(id).subscribe((res: any) => {
    if (res.success === true && Array.isArray(res.data)) {
      const devicePlaylistData = res.data
        .filter((item: any) => item.playlist !== null)
        .map((item: any) => ({
          ...item.playlist,
          device_id: item.device_id,
          local: true,
          app_mode: 'activate'
        }));

      // Merge new data with any existing non-duplicate entries
      const merged = [
        ...parsedData.filter(p => !devicePlaylistData.some(n => n.id === p.id)),
        ...devicePlaylistData
      ];

      localStorage.setItem('xstream_playlists', JSON.stringify(merged));
      console.log('Fetched and merged device playlists:', merged);
    }
  });
}



  getLocalPlaylist(){
    const localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
    this.filterPlayList = localPlaylists;
    console.log(localPlaylists);
  }

  checkDuplicateName(name) {
    let found = false;
    const inputName = name.toLowerCase();
    for (let index = 0; index < this.filterPlayList.length; index++) {
      const existingName = this.filterPlayList[index].playlist_name.toLowerCase();
      if (existingName === inputName) {
        found = true;
        this.utilService.showErrorToast('', 'Playlist name must be unique');
        break;
      }
    }
    return !found;
  }
//   checkDuplicateNameEdit(name: string, ignoreId?: number): boolean {
//   const playlists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
//  console.log(ignoreId);
 
//   return playlists.some((p: any) =>
//     p.playlist_name.trim().toLowerCase() === name.trim().toLowerCase() &&
//     p.playlist_id !== ignoreId 
//   );
// }

checkDuplicateNameEdit(name: string, ignoreId?: number): boolean {
  const playlists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');

  return playlists.some((p: any) => {
    const nameMatch = p.playlist_name.trim().toLowerCase() === name.trim().toLowerCase();
    const idCheck = ignoreId !== undefined ? p.playlist_id !== ignoreId : true;
    return nameMatch && idCheck;
  });
}


  
  

 async addPlaylistM3u(form: NgForm) {
    
    if (form.valid && this.checkDuplicateNameEdit(this.playListModal.name)) {
       const isValidM3U = await this.getM3uListParse(this.playListModal.url);
       if (!isValidM3U) return; // stop if no #EXTINF found
      let passModel: any = {
        type:2,
        url: this.playListModal.url,
        name: this.playListModal.name,
        // userid: this.utilService.getFullUserId()
      };

      // this.getM3uListParse(this.playListModal.url)
      this.isLoading = true;
      this.utilService.showSpinner()
      if(this.playList.length < 5  && this.userid){ 
        this.playlistService.addPlaylistM3u(passModel).subscribe((res: any) => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          if (res.status == 'success') {
            this.utilService.showErrorSuccess('m3u playlist is added successfully');
            this.getPlayList();
            this.playListModal.url = '';
            this.playListModal.name = '';
            this.closeModal();
          }
        }, err => {
          this.isLoading = false;
          this.utilService.hideSpinner()
          this.utilService.showErrorToast(err.error.message); // show the error 
          
        });
      }else{
        const fakeResponse = {
          status: 'success',
          message: 'Playlist added successfully',
          data: {
            user_id: this.userid, // You can use a utility function or random ID
            playlist_name: passModel.name,
            type: passModel.type,
            reseller_code: null,
            m3u_url: passModel.url,
            username: null,
            password: null,
            epg: null,
            user_agent: null,
            updated_at: new Date().toISOString(),
            created_at: new Date().toISOString(),
            id: Date.now(),
            local:true
          }
        };
        console.log(fakeResponse);
        
        let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        localPlaylists.push(fakeResponse.data);
        localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        this.filterPlayList.push(fakeResponse.data);
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorSuccess(fakeResponse.message);

        this.closeModal();
        this.playListModal = {
          type: 'fromUrl',
          name: '',
          userName: '',
          password: '',
          url: ''
        };
      }
    }
  }
   getM3uListParse(url: string): Promise<boolean> {
  return new Promise((resolve, reject) => {
    this.isLoading = true;
    this.playlistService.parsem3uList(url).subscribe({
      next: (res: string) => {
        this.isLoading = false;
        const hasExtInf = this.checkForExtInf(res);
        if (hasExtInf) {
          this.parse(res); // optionally parse if needed
          resolve(true);
        } else {
          this.utilService.showErrorToast('Invalid M3U URL. No #EXTINF tags found.');
          resolve(false);
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.utilService.showErrorCall(err);
        resolve(false);
      }
    });
  });
}
checkForExtInf(m3uText: string): boolean {
  return m3uText.includes('#EXTINF');
}

   parse(res: string) {
    this.playlistM3u = [];
    let lines = res.split('\n').filter(line => line.trim().length > 0);

    lines.forEach((line, index) => {
      if (line.startsWith('#EXTINF')) {

      }})
    }

  addPlaylistXstream(form: NgForm) {
    if (form.valid && this.checkDuplicateName(this.playListModal.name)) {
      let passModel: any = {
        type:1,
        url: this.playListModal.url,
        pwd: this.playListModal.password,
        name: this.playListModal.name,
        username: this.playListModal.userName
      };

      this.isLoading = true;
      this.utilService.showSpinner()
      if(this.playList.length < 5  && this.userid){
        this.playlistService.addNewXstreamPlaylist(passModel).subscribe((res: any) => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          if (res.status == 'success') {
            // , res.status
            this.utilService.showErrorSuccess('xstream playlist is added successfully');
            this.getPlayList();
            this.closeModal();
            this.playListModal = {
              type: 'fromUrl',
              name: '',
              userName: '',
              password: '',
              url: ''
            };
          }
        }, err => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          this.utilService.showErrorCall(err);
        });
      }else{
        const fakeResponse = {
          status: 'success',
          message: 'Playlist added successfully',
          data: {
            user_id: this.userid, // You can use a utility function or random ID
            playlist_name: passModel.name,
            type: passModel.type,
            reseller_code: null,
            dns: passModel.url,
            username: passModel.username,
            password: passModel.pwd,
            epg: null,
            user_agent: null,
            updated_at: new Date().toISOString(),
            created_at: new Date().toISOString(),
            id: Date.now(),
            local:true
          }
        };


        
        // let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        // localPlaylists.push(fakeResponse.data);
        // localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        // this.filterPlayList.push(fakeResponse.data);
        // this.isLoading = false;
        // this.utilService.hideSpinner();
        // this.utilService.showErrorSuccess(fakeResponse.message);

        // this.closeModal();
        // this.playListModal = {
        //   type: 'fromUrl',
        //   name: '',
        //   userName: '',
        //   password: '',
        //   url: ''
        // };
        const url = this.createUrl(passModel.username,passModel.pwd,passModel.url)
        if(url){
          this.authService.validateURL(url).subscribe((res:any)=>{
            if(res){
              let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        localPlaylists.push(fakeResponse.data);
        localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        this.filterPlayList.push(fakeResponse.data);
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorSuccess(fakeResponse.message);

        this.closeModal();
        this.playListModal = {
          type: 'fromUrl',
          name: '',
          userName: '',
          password: '',
          url: ''
            };
            }
            
          },err =>{
           this.authService.validatePostURL(passModel).subscribe((res:any)=>{
            if(res){
              let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
              localPlaylists.push(fakeResponse.data);
              localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
              this.filterPlayList.push(fakeResponse.data);
              this.isLoading = false;
              this.utilService.hideSpinner();
              this.utilService.showErrorSuccess(fakeResponse.message);

              this.closeModal();
              this.playListModal = {
                type: 'fromUrl',
                name: '',
                userName: '',
                password: '',
                url: ''
              };
            }
           },err =>{
            this.isLoading = false;
            this.utilService.hideSpinner()
            this.utilService.showErrorToast('Please enter valid url ,username ,password')
           })
            
          })
        }

      }
    }
  }

  addPlaylistOnestream(form:NgForm) {
    if (form.valid && this.checkDuplicateName(this.playListModal.name)) {
      console.log(this.playListModal.name,'Name one stream');
      
      let passModel: any = {
        type:4,
        url: this.playListModal.url,
        pwd: this.playListModal.password,
        name: this.playListModal.name,
        username: this.playListModal.userName
      };

      this.isLoading = true;
      this.utilService.showSpinner()
      if(this.playList.length < 5  && this.userid){
        
        this.playlistService.addNewXstreamPlaylist(passModel).subscribe((res: any) => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          if (res.status == 'success') {
            // , res.status
            this.utilService.showErrorSuccess('xstream playlist is added successfully');
            this.getPlayList();
            this.closeModal();
            this.playListModal = {
              type: 'fromUrl',
              name: '',
              userName: '',
              password: '',
              url: ''
            };
          }
        }, err => {
          this.isLoading = false;
          this.utilService.hideSpinner()
  
          this.utilService.showErrorCall(err);
        });

      }else{
        const fakeResponse = {
          status: 'success',
          message: 'Playlist added successfully',
          data: {
            user_id: this.userid, // You can use a utility function or random ID
            playlist_name: passModel.name,
            type: passModel.type,
            reseller_code: null,
            dns: passModel.url,
            username: passModel.username,
            password: passModel.pwd,
            epg: null,
            user_agent: null,
            updated_at: new Date().toISOString(),
            created_at: new Date().toISOString(),
            id: Date.now(),
            local:true
          }
        };
  
        let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        localPlaylists.push(fakeResponse.data);
        localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        this.filterPlayList.push(fakeResponse.data);
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorSuccess(fakeResponse.message);

        this.closeModal();
        this.playListModal = {
          type: 'fromUrl',
          name: '',
          userName: '',
          password: '',
          url: ''
        };
      }  
    }
  }
// async clearPlaylistMovies(playlist_id: number): Promise<void> {
//   await Moviesdb.movies
//     .where('playlist_id')
//     .equals(playlist_id)
//     .delete();
// }

  deleteItem(id :any,islocal:boolean) {
    // ev.stopPropagation();
    // ev.preventDefault();
    this.messageService.confirm('Delete!', 'Are you sure you want to delete?')
      .subscribe((answer) => {
        if (answer === 'Yes') {
          let passModel: any = {
            // url: url,
            // type: type,
            // userid: this.utilService.getFullUserId()
            id:id,
            local:islocal
          };
          this.isLoading = true;
          this.utilService.showSpinner()
          console.log(passModel);
          if(passModel.local == true)
          {
          this.utilService.deleteAllDataByPlaylistId(id)
          let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
          localPlaylists = localPlaylists.filter((item: any) => item.id !== passModel.id);
          localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
          this.filterPlayList = this.filterPlayList.filter(item => item.id !== passModel.id);
          this.isLoading = false;
          this.utilService.hideSpinner();
          this.getPlayList();
          this.utilService.clearData()
          this.utilService.showErrorSuccess('Playlist deleted from local storage.');
          }else{
            this.playlistService.deletePlaylistItem(passModel).subscribe((res: any) => {
              this.isLoading = false;
              this.utilService.hideSpinner()
              if (res.status == 'success') {
                this.utilService.deleteAllDataByPlaylistId(id)
                this.utilService.showErrorSuccess('', res.status);
                this.getPlayList();
              }
              if(res.detail.http_code == 403){
                this.isLoading = false;
                this.utilService.hideSpinner()
                this.utilService.showErrorToast(res.detail.status)
              }
  
            },(err:any) =>{
              this.isLoading = false
                this.utilService.hideSpinner()
                this.utilService.showErrorToast(err.error.message);
                if(err.status == 403){
                }
            });
          }

        }
      });
      }
  deleteCode(id :any,islocal:boolean){
    this.messageService.confirm('Delete!', 'Are you sure you want to delete?')
    .subscribe((answer) => {
      if (answer === 'Yes') {
        this.isLoading = true;
        this.utilService.showSpinner();

        let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
        localPlaylists = localPlaylists.filter((item: any) => item.id !== id);
        localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
        this.filterPlayList = localPlaylists;
        this.getPlayList()
        this.isLoading = false;
        this.utilService.hideSpinner();
        this.utilService.showErrorSuccess('Playlist deleted from local storage.');
      }
    });
  }


  cloudPlaylist(data: any) {
        this.isLoading = true;
        this.utilService.showSpinner();
      
        let passModel: any = {
          type: data.type,
          url: data.type == 2 ? data.m3u_url : data.dns,
          password: data.password,
          playlist_name: data.playlist_name,
          username: data.username,
          // playlist_id:data.id
        };
      
        console.log(passModel, 'passmodel');
      
        const request$ = data.type == 2
          ? this.playlistService.addPlaylistM3u(passModel)
          : this.playlistService.addNewXstreamPlaylist(passModel);
      
        request$.subscribe(
          (res: any) => {
            this.isLoading = false;
            this.utilService.hideSpinner();
      
            if (res.status == 'success') {
              this.utilService.showErrorSuccess('xstream playlist is added successfully');
              this.deleteLocalOnCloud(data.id, data.local);
              this.closeModal();
              this.playListModal = {
                type: 'fromUrl',
                name: '',
                userName: '',
                password: '',
                url: ''
              };
            }
          },
          err => {
            this.isLoading = false;
            this.utilService.hideSpinner();
            this.utilService.showErrorCall(err);
          }
        );
      }
      
  editPlaylists(data:any){
    let passModel: any = {
      type:data.type,
      url: data.dns,
      pwd: data.password,
      name: data.playlist_name,
      username: data.username
    };
    console.log(data,'edit playlist',passModel);
     
  }
  editPlaylist_(data: any) {
    const passModel = {
      playlist_id:data.id,
      type: data.type,
      url: data.type == 2 ? data.m3u_url : data.dns || data.dns_id?.dns_url,
      pwd: data.password,
      name: data.playlist_name,
      username: data.username,
      local:data.local || false
    };
    
    console.log(data);
    
    this.messageService.editPlaylistDialog(passModel).subscribe((editedData) => {
      console.log(editedData);
      
      if (this.checkDuplicateNameEdit(editedData.name,editedData.playlist_id)) {
      const editedPlaylist =
      {
        playlist_id:editedData.id,
        type: editedData.type,
        url: editedData.type == 2 ? editedData.m3u_url : editedData.dns,
        pwd: editedData.password,
        name: editedData.playlist_name,
        username: editedData.username,
        local: editedData.local || false
      }
      if (editedData) {
        // console.log('Updated Playlist:', editedData);
      if(editedData.local == true){
            console.log('local ==>',editedData);
                    const newId = Date.now();

             const playlists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
             console.log(playlists);
             
    // 2. Find index of playlist with matching ID


      const index = playlists.findIndex((p: any) => p.id === editedData.playlist_id);
      console.log('edit',playlists,index);
      if (index !== -1) {
      // 3. Update the matched playlist with new values
      playlists[index] = {
        ...playlists[index], // keep existing unchanged fields like user_id, created_at
        id:newId,
        playlist_name: editedData.name,
        type: editedData.type,
        dns: editedData.type !== 2 ? editedData.url : null,
        m3u_url: editedData.type === 2 ? editedData.url : null,
        username: editedData.username,
        password: editedData.pwd,
        updated_at: new Date().toISOString(),
        local: editedData.local
      };
      // 4. Save back to localStorage
      this.utilService.deleteAllDataByPlaylistId(data.id);
      localStorage.setItem('xstream_playlists', JSON.stringify(playlists));
      this.getPlayList();
    }
          
        }else{
          console.log(editedPlaylist);
          const request$ = editedData.type == 2
          ? this.playlistService.addPlaylistM3us(editedData)
          : this.playlistService.addNewXstreamPlaylists(editedData);
        request$.subscribe(
          (res: any) => {
            this.isLoading = false;
            this.utilService.hideSpinner();
      
            if (res.status == 'success') {
              this.utilService.showErrorSuccess('xstream playlist is added successfully');
              this.getPlayList()
              this.playListModal = {
                type: 'fromUrl',
                name: '',
                userName: '',
                password: '',
                url: ''
              };
            }
          },
          err => {
            this.isLoading = false;
            this.utilService.hideSpinner();
            this.utilService.showErrorCall(err);
          }
        );
      }
        
      }
      }
    });
  }
  editPlaylist(data: any) {
  const passModel = {
    playlist_id: data.id,
    type: data.type,
    url: data.type == 2 ? data.m3u_url : data.dns || data.dns_id?.dns_url,
    pwd: data.password,
    name: data.playlist_name,
    username: data.username,
    local: data.local || false
  };

  this.messageService.editPlaylistDialog(passModel).subscribe((editedData) => {
    if (!editedData) return;
    
    const playlists = JSON.parse(localStorage.getItem('purple_playlist') || '[]');
    const localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');

    // Combine both for global duplicate check
    const allPlaylists = [...playlists, ...localPlaylists];

    // Check for duplicate name excluding the currently edited playlist
    const isDuplicate = allPlaylists.some((p: any) =>
      p.playlist_name?.trim().toLowerCase() === editedData.name.trim().toLowerCase() &&
      p.id !== editedData.playlist_id
    );

    if (isDuplicate) {
      this.utilService.showErrorToast('Playlist name already exists');
      return;
    }

    

    // Check for duplicate name (excluding current playlist)
    // const isDuplicate = playlists.some((p: any) =>
    //   p.playlist_name.trim().toLowerCase() === editedData.name.trim().toLowerCase() &&
    //   p.id !== editedData.playlist_id
    // );

    // if (isDuplicate) {
    //   this.utilService.showErrorToast('Playlist name already exists');
    //   return;
    // }

    

    if (editedData.local === true) {
       const playlists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
    const index = playlists.findIndex((p: any) => p.id === editedData.playlist_id);
    console.log(index);
    
    if (index === -1) return;

    const original = playlists[index];

    // Check for duplicate name (excluding current playlist)
    const isDuplicate = playlists.some((p: any) =>
      p.playlist_name.trim().toLowerCase() === editedData.name.trim().toLowerCase() &&
      p.id !== editedData.playlist_id
    );

    if (isDuplicate) {
      this.utilService.showErrorToast('Playlist name already exists');
      return;
    }

    // Check which fields changed
    const isNameChanged = original.playlist_name !== editedData.name;
    const isUrlChanged = (original.type === 2 ? original.m3u_url : original.dns) !== editedData.url;
    const isUsernameChanged = original.username !== editedData.username;
    const isPasswordChanged = original.password !== editedData.pwd;
      // Case 1: Only name changed -> update name
      if (isNameChanged && !isUrlChanged && !isUsernameChanged && !isPasswordChanged) {
        playlists[index].playlist_name = editedData.name;
        playlists[index].updated_at = new Date().toISOString();
      } else {
        // Case 2: Other changes → assign new ID
        const newId = Date.now();
        playlists[index] = {
          ...original,
          id: newId,
          playlist_id: newId, // important: update both!
          playlist_name: editedData.name,
          type: editedData.type,
          dns: editedData.type !== 2 ? editedData.url : null,
          m3u_url: editedData.type === 2 ? editedData.url : null,
          username: editedData.username,
          password: editedData.pwd,
          updated_at: new Date().toISOString(),
          local: true
        };

        // Clear old data from Dexie/IndexedDB
        this.utilService.deleteAllDataByPlaylistId(data.id);
      }

      // Save and refresh
      localStorage.setItem('xstream_playlists', JSON.stringify(playlists));
      this.getPlayList();
    } else {
      // Handle remote playlist updates
      console.log(editedData);
      
      const request$ = editedData.type === '1' || editedData.type === 1
        ?  this.playlistService.addNewXstreamPlaylists(editedData):this.playlistService.addPlaylistM3us(editedData)

      request$.subscribe(
        (res: any) => {
          this.isLoading = false;
          this.utilService.hideSpinner();
          if (res.status == 'success') {
            this.utilService.showErrorSuccess('xstream playlist is added successfully');
            this.getPlayList();
            this.playListModal = {
              type: 'fromUrl',
              name: '',
              userName: '',
              password: '',
              url: ''
            };
          }
        },
        err => {
          this.isLoading = false;
          this.utilService.hideSpinner();
          this.utilService.showErrorCall(err);
        }
      );
    }
  });
}


  close(){
    const modalElement = document.getElementById('editPlaylistModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.hide();
    }
    
  }

  deleteLocalOnCloud(id :any,islocal:boolean){
    let passModel: any = {
      // url: url,
      // type: type,
      // userid: this.utilService.getFullUserId()
      id:id,
      local:islocal
    };
    if(passModel.local == true)
      {
      let localPlaylists = JSON.parse(localStorage.getItem('xstream_playlists') || '[]');
      localPlaylists = localPlaylists.filter((item: any) => item.id !== passModel.id);
      localStorage.setItem('xstream_playlists', JSON.stringify(localPlaylists));
      this.filterPlayList = this.filterPlayList.filter(item => item.id !== passModel.id);
      this.isLoading = false;
      this.utilService.hideSpinner();
      this.getPlayList();
      this.utilService.showErrorSuccess('Playlist deleted from local storage.');
  }
  }

  closeModal() {
    this.bsModalRef.hide();
  }
  openModal(template: any) {
    this.bsModalRef = this.modalService.show(template, { class: 'modal-dialog-centered' });
  }

  onLogout() {
    this.utilService.logout(true);
  }

 async onSelectPlaylist(item: any) {
    let decodeUrl;
    
    if(item.local == true){
      console.log(item);
      if(item.type == 2){
        decodeUrl = encodeURIComponent(item.m3u_url);
        this.router.navigate(['/watchlist'], { queryParams: { url: decodeUrl } });
      }else{
        if (item.appLogo) {
          this.utilService.saveValueStorage(Constant.APP_LOGO, item.appLogo);
        } else {
          this.utilService.removeLocalStorage(Constant.APP_LOGO);
        }

        if (item.appBackground) {
          this.utilService.saveValueStorage(Constant.APP_BACKGROUND, item.appBackground);
        } else {
          this.utilService.removeLocalStorage(Constant.APP_BACKGROUND);
        }
       
         localStorage.setItem('playlist',JSON.stringify(item));
          const movieCount = await Moviesdb.movies
        .where('playlist_id')
        .equals(item.id)
        .count();

      const categoryCount = await Moviesdb.categories
        .where('playlist_id')
        .equals(item.id)
        .count();

      if (movieCount > 0 || categoryCount > 0) {
        console.log(`Playlist ID ${item.id} already exists in DB. Skipping loading modal.`);
        localStorage.setItem('isLocalPlaylist', 'true');
        localStorage.setItem('localProfile', JSON.stringify(item));
        this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, item.user_id);
        this.utilService.saveValueStorage(Constant.FULLUSERNAME_KEY, item.username);
        this.utilService.saveValueStorage(Constant.FULLPASSWORD_KEY, item.password);
        this.utilService.saveValueStorage(Constant.FULLURL_KEY, item.dns);
        this.router.navigate(['/home']);
        return;
      }
        this.bsModalRef = this.modalService.show(LoadingDbModalComponent, {
          class: 'modal-fullscreen',
          initialState: {
            playlistItem: item
          },
          ignoreBackdropClick: true,
          keyboard: false,
        });

        this.bsModalRef.content.onClose.subscribe((result: string) => {
          if (result === 'yes') {
            console.log('Loading complete');
            localStorage.setItem('isLocalPlaylist','true')
            localStorage.setItem('localProfile',JSON.stringify(item))
          } else {
            console.warn('Loading failed or cancelled');
          }
        });

                    
  
        // this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, item.user_id);
        // this.utilService.saveValueStorage(Constant.FULLUSERNAME_KEY, item.username);
        // this.utilService.saveValueStorage(Constant.FULLPASSWORD_KEY, item.password);
        // this.utilService.saveValueStorage(Constant.FULLURL_KEY,  item.dns);
        //     const  total = await this.livetvService.loadLivetv();
        //     const categorieslive = await this.livetvService.loadLivetvCategories();
        //     const totalmovies = await this.moviesService.loadMovies();
        //     const moviescategories = await this.moviesService.loadCategories();
        //     const seriesCategory = await this.seriesService.loadCategories();
        //     const totalseries = await this.seriesService.loadSeries();
        // this.router.navigate(['/home']);
      }
    }
    else if(item.type == 2){
      // this.router.navigate(['/watchlist'])
      decodeUrl = encodeURIComponent(item.m3u_url);
      this.router.navigate(['/watchlist'], { queryParams: { url: decodeUrl } });
    }
    else{
      const url = this.createUrl(item.username,item.password,item.dns)
      if(url){
        this.authService.validateURL(url).subscribe((res:any)=>{
          if(res){
            console.log(res);
            if(this.isLogin === false){
             this.saveDb(item);
            }else{
              // this.router.navigate(['/profile',item.id])
              localStorage.setItem('playlist',JSON.stringify(item));
              this.router.navigate(['/profile'],{state:{id:item.id,playlist_name:item.playlist_name,username:item.username,password:item.password,dns:item.dns}})
            }

          }
          
        },err =>{
         this.authService.validatePostURL(item).subscribe((res:any)=>{
          if(res){
            console.log(res.user_info);
            // this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, item.user_id);
            // this.utilService.saveValueStorage(Constant.FULLUSERNAME_KEY, item.playlist_name);
            // this.utilService.saveValueStorage(Constant.FULLPASSWORD_KEY, item.password);
            // this.utilService.saveValueStorage(Constant.FULLURL_KEY,  item.dns);
            // this.router.navigate(['/home']);
            // this.router.navigate(['/profile',item.id])
            this.router.navigate(['/profile'],{state:{id:item.id,playlist_name:item.playlist_name,password:item.password,dns:item.dns}})
            
          }
         },err=>{
          this.utilService.showErrorToast("Something went wrong!")
         })
          
        })
      }
    }

  }

  async saveDb(item){
    try { 
          this.isLoadingdb = true;
          this.utilService.saveValueStorage(Constant.FULLUSERID_KEY, item.user_id);
          this.utilService.saveValueStorage(Constant.FULLUSERNAME_KEY, item.username);
          this.utilService.saveValueStorage(Constant.FULLPASSWORD_KEY, item.password);
          this.utilService.saveValueStorage(Constant.FULLURL_KEY,  item.dns);
          // await this.livetvService.loadLivetv();
          // await this.livetvService.loadLivetvCategories();
          // await this.moviesService.loadMovies();
          // await this.moviesService.loadCategories();
          // await this.seriesService.loadCategories();
          // await this.seriesService.loadSeries();
          const totalItems = this.loadingItems.length;
          let completed = 0;

          // LIVE TV
          this.currentLabel = 'Loading Live TV categories...';
          await this.livetvService.loadLivetvCategories();
          this.currentLabel = 'Loading Live TV streams...';
          await this.livetvService.loadLivetv();
          this.markLoaded(0, ++completed, totalItems);

          // MOVIES
          this.currentLabel = 'Loading Movie categories...';
          await this.moviesService.loadCategories();
          this.currentLabel = 'Loading Movies...';
          await this.moviesService.loadMovies();
          this.markLoaded(1, ++completed, totalItems);

          // SERIES
          this.currentLabel = 'Loading Series categories...';
          await this.seriesService.loadCategories();
          this.currentLabel = 'Loading Series...';
          await this.seriesService.loadSeries();
          this.markLoaded(2, ++completed, totalItems);

          this.currentLabel = 'All content loaded!';
          this.router.navigate(['/home']);

          this.router.navigate(['/home']);


        } catch (error) {
          console.error("Error loading data", error);
          localStorage.setItem('progressComplete','false')
          this.isLoadingdb = false;

        } finally {
          localStorage.setItem('progressComplete','true')
          this.isLoadingdb = false;
        }

  }

  markLoaded(index: number, completed: number, total: number) {
  this.loadingItems[index].loaded = true;
  this.loadingItems[index].progress = 100;
  this.overallProgress = Math.round((completed / total) * 100);
}

async wrapAndTrack(task: () => Promise<any>) {
  await task();
  this.progress += Math.round(100 / this.totalTasks);
  console.log(this.progress);
  
}

  navigateCode(){
    this.closeModal();
    this.router.navigate(['/code'])
  }


  createUrl(user:string,password:any,url:string){
    return  `${url}/player_api.php?username=${user}&password=${password}`
  }

  hideShowPassword() {
    if (this.type === 'password') {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  clearStorage(){
    this.utilService.logout()
  }
  

}